import { render, staticRenderFns } from "./SurveyScoreResult.vue?vue&type=template&id=3f373526&scoped=true&"
import script from "./SurveyScoreResult.vue?vue&type=script&lang=ts&"
export * from "./SurveyScoreResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f373526",
  null
  
)

export default component.exports